import Vue from "vue";
import Vuetify, { VTextarea, VRow,VCheckbox,VDatePicker } from "vuetify/lib";
import i18n from "@/i18n";
// import "@/sass/overrides.sass";

Vue.use(Vuetify, {
    components: {
        VTextarea,
        VRow,
        VDatePicker,
        VCheckbox
    },
});

const theme = {
  primary: "#4e8fe0",
  secondary: "#9C27b0",
  accent: "#9C27b0",
  info: "#00CAE3",
};

export default new Vuetify({
    rtl: true,
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
});
